<template>
  <v-layout>
    <!-- <v-btn
      depressed
      :color="light ? 'white' : 'primary'"
      outlined
      large
      class="rounded-lg mr-2"
      :to="`/agent/create/${$helpers.getFilePreview($helpers.get(authUser, '_id'))}`"
    >
      Complete Your Profile
    </v-btn> -->
    <v-btn
      depressed
      large
      :color="light ? 'white' : 'primary'"
      :class="light ? 'primary--text' : 'white--text'"
      class="rounded-lg"
      :data-cy="$dataCy.BtnCreateContentStream"
      @click.prevent="createStream"
    >
      Create Content Streams
    </v-btn>

    <e-dialog
      :value="value"
      :title-line="false"
      dense
      max-width="941"
      @close="hide"
    >
      <v-layout column class="pt-3 pb-11 px-18 justify-space-between text-center">
        <h2 class="text-h4 font-weight-bold black--text">
          Create a Content Stream
        </h2>
        <h3 class="mb-2 text-h5 font-weight-medium black--text">
          How would you like to start your new stream?
        </h3>

        <v-layout wrap class="justify-center">
          <v-flex xs4 class="pa-2">
            <v-btn
              depressed
              color="#F8F8F8"
              class="black--text rounded-lg border border-solid border-secondary v-btn-full"
              height="100%"
              :data-cy="$dataCy.BtnGeneralSaleMarketing"
              data-test-id="btn-from-template"
              :disabled="loading"
              @click="createGeneralSalesMarketing"
            >
              <v-layout column class="py-2">
                <img :src="'streams/create/template.png' | assetImageUrl" height="107" class="mx-auto mb-2">
                <h6 class="mb-1 text-subtitle-1">
                  General Sales & Marketing
                </h6>
                <p class="mb-0 text-body-2 text-desc">
                  Choose from our templates.
                </p>
              </v-layout>
            </v-btn>
          </v-flex>

          <v-flex xs4 class="pa-2">
            <v-btn
              depressed
              color="#F8F8F8"
              class="black--text rounded-lg border border-solid border-secondary v-btn-full"
              height="100%"
              :data-cy="$dataCy.BtnPaidProduct"
              :disabled="loading"
              @click="createPaidProduct"
            >
              <v-layout column class="py-2">
                <img :src="'streams/create/paid-product.png' | assetImageUrl" height="107" class="mx-auto mb-2">
                <h6 class="mb-1 text-subtitle-1">
                  Paid Product
                </h6>
                <p class="mb-0 text-body-2 text-desc">
                  Generate revenue with Product and Sales Templates
                </p>
              </v-layout>
            </v-btn>
          </v-flex>

          <v-flex xs4 class="pa-2">
            <v-btn
              depressed
              color="#F8F8F8"
              class="black--text rounded-lg border border-solid border-secondary v-btn-full"
              height="100%"
              data-test-id="btn-from-listing"
              :data-cy="$dataCy.BtnSinglePropertyWebsite"
              :disabled="loading"
              @click="createSinglePropertyWebsite"
            >
              <v-layout column class="py-2">
                <img :src="'streams/create/single-property.png' | assetImageUrl" height="107" class="mx-auto mb-2">
                <h6 class="mb-1 text-subtitle-1">
                  Single Property Website
                </h6>
                <p class="mb-0 text-body-2 text-desc">
                  Create a Single Property Website.
                </p>
              </v-layout>
            </v-btn>
          </v-flex>

          <v-flex xs4 class="pa-2">
            <v-btn
              depressed
              color="#F8F8F8"
              class="black--text rounded-lg border border-solid border-secondary v-btn-full"
              height="100%"
              :data-cy="$dataCy.BtnBiolink"
              :disabled="loading"
              @click="createBiolink"
            >
              <v-layout column class="py-2">
                <img :src="'streams/create/biolink.png' | assetImageUrl" height="107" class="mx-auto mb-2">
                <h6 class="mb-1 text-subtitle-1">
                  Bio link
                </h6>
                <p class="mb-0 text-body-2 text-desc">
                  Create a Bio link.
                </p>
              </v-layout>
            </v-btn>
          </v-flex>

          <v-flex xs4 class="pa-2">
            <v-btn
              depressed
              color="#F8F8F8"
              class="black--text rounded-lg border border-solid border-secondary v-btn-full"
              height="100%"
              :data-cy="$dataCy.BtnNewsletter"
              :disabled="loading"
              @click.once="createNewsletter"
            >
              <v-layout column>
                <img :src="'streams/create/newsletter.png' | assetImageUrl" height="107" class="mx-auto mb-2">
                <h6 class="mb-1 text-subtitle-1">
                  Newsletter
                </h6>
                <p class="mb-0 text-body-2">
                  Create a Newsletter.
                </p>
              </v-layout>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-layout>
    </e-dialog>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'BtnCreateStream',

  props: {
    promotionalContentTemplateId: {
      type: String,
      default: ''
    },
    light: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    loading: false,
    value: false
  }),
  computed: {
    authUser() {
      return this.$auth.user
    },
    ...mapGetters(['popupAction'])
  },
  watch: {
    popupAction(val) {
      if (this.$helpers.get(val, 'action') === 'gettingStarted.contentStream.firstStream') {
        this.show()
      }
      if (this.$helpers.get(val, 'action') === 'gettingStarted.singlePropertyPage.firstSinglePropertyPage') {
        this.createSinglePropertyWebsite()
      }
    }
  },
  methods: {
    show() {
      this.value = true
    },
    hide() {
      this.value = !this.value
    },
    createStream() {
      this.$helpers.tractMixpanel('dashboard_create_click', 'create stream ')
      this.show()
    },
    useTemplate(type) {
      this.$router.push({
        name: 'streams-create',
        query: {
          type,
          promotionalContentTemplateId: this.promotionalContentTemplateId || undefined
        }
      })
    },
    createGeneralSalesMarketing() {
      this.loading = true
      this.useTemplate()
      this.$helpers.gaTracking('Dashboard', 'dashboard_create_click', 'use template', { event_type: 'use template' })
    },
    createPaidProduct() {
      this.loading = true
      this.useTemplate('paid-product')
    },
    createSinglePropertyWebsite() {
      this.loading = true
      this.useTemplate('single-property')
    },
    createBiolink() {
      this.loading = true
      this.useTemplate('biolink')
    },
    createNewsletter() {
      this.loading = true
      this.useTemplate('newsletter')
    }
  }
}
</script>

<style lang="scss" scoped>
.text-desc {
  white-space: normal;
  line-height: 1.5;
}
</style>
